import React from 'react';

import { ModalNotStyled } from 'ui-kit';

import { AssetClass, Filter, FilterableField, FilterOperator } from '__generated__/globalTypes';
import CreatePoolForm from '../pages/portfolio/CreatePoolForm';
import { buildSuggestedPoolName } from './tapePoolNaming';
import { useCreatePoolFromTape } from './useCreatePoolFromTape';

type Props = {
  /**
   * Caller-controlled visibility. The modal is mounted only while open, so
   * its FloatingPortal lifecycle aligns with the open transition — this is
   * what lets us close an enclosing overlay first and then mount the modal
   * fresh, sidestepping the z-50 vs z-20 stacking conflict.
   */
  open: boolean;
  onClose: () => void;
  /** Tape this pool will scope to. */
  tape: {
    tapeId: string;
    tapeName: string;
    assetClass: AssetClass;
  };
};

const PoolFromTapeModal = ({ open, onClose, tape }: Props): JSX.Element | null => {
  const { tapeId, tapeName, assetClass } = tape;

  const tapeFilter: Filter[] = [
    {
      field_name: FilterableField.last_loan_tape_id,
      operator: FilterOperator.IS,
      operand: tapeId,
      operandList: null,
    },
  ];

  const { submit } = useCreatePoolFromTape({ tapeFilter, gqlAssetClass: assetClass });

  if (!open) return null;

  const suggestedName = buildSuggestedPoolName(tapeName, new Date());

  return (
    <ModalNotStyled initialOpen={true} handleClose={onClose}>
      {({ closeModal }) => (
        <CreatePoolForm
          closeModal={closeModal}
          createPool={submit}
          initialPoolName={suggestedName}
          subheaderText={`Pooling all loans from ${tapeName}. Edit the name below if you'd like.`}
        />
      )}
    </ModalNotStyled>
  );
};

export default PoolFromTapeModal;
